import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BulkReceiveSkuSearchQueryVariables = Types.Exact<{
  name?: Types.InputMaybe<Types.Scalars['String']>;
  facilityId: Types.Scalars['String'];
}>;


export type BulkReceiveSkuSearchQuery = { readonly __typename?: 'Query', readonly inventorySearchTmp: { readonly __typename?: 'InventorySummaryConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'InventorySummaryEdge', readonly node: { readonly __typename?: 'InventorySummary', readonly id: string, readonly name: string } }> } };


export const BulkReceiveSkuSearchDocument = gql`
    query bulkReceiveSkuSearch($name: String, $facilityId: String!) {
  inventorySearchTmp(
    input: {name: $name, facilityId: $facilityId, active: true}
    options: {pageSize: 50, order: {by: NAME_RELAVANCE}}
  ) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useBulkReceiveSkuSearchQuery__
 *
 * To run a query within a React component, call `useBulkReceiveSkuSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkReceiveSkuSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkReceiveSkuSearchQuery({
 *   variables: {
 *      name: // value for 'name'
 *      facilityId: // value for 'facilityId'
 *   },
 * });
 */
export function useBulkReceiveSkuSearchQuery(baseOptions: Apollo.QueryHookOptions<BulkReceiveSkuSearchQuery, BulkReceiveSkuSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkReceiveSkuSearchQuery, BulkReceiveSkuSearchQueryVariables>(BulkReceiveSkuSearchDocument, options);
      }
export function useBulkReceiveSkuSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkReceiveSkuSearchQuery, BulkReceiveSkuSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkReceiveSkuSearchQuery, BulkReceiveSkuSearchQueryVariables>(BulkReceiveSkuSearchDocument, options);
        }
export type BulkReceiveSkuSearchQueryHookResult = ReturnType<typeof useBulkReceiveSkuSearchQuery>;
export type BulkReceiveSkuSearchLazyQueryHookResult = ReturnType<typeof useBulkReceiveSkuSearchLazyQuery>;
export type BulkReceiveSkuSearchQueryResult = Apollo.QueryResult<BulkReceiveSkuSearchQuery, BulkReceiveSkuSearchQueryVariables>;